var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-card',{staticStyle:{"height":"95%"}},[_c('h2',{staticStyle:{"font-size":"30px","margin":"0px","padding":"0px"}},[_vm._v("401, 抱歉~,您无权访问该页面")])])
}
var staticRenderFns = []

export { render, staticRenderFns }